<div
  id="main"
  class="wrapper"
  [class.minimized]="isNavbarMinimized"
  [class.ai-assistant-open]="jaxState.isOpen()"
>
  <div
    class="overlay"
    [class.active]="!isNavbarCollapsed"
    (click)="collapseNav()"
  ></div>
  <nav
    id="sidebar"
    class="d-flex align-items-start flex-column"
    [ngbCollapse]="isNavbarCollapsed"
  >
    <div
      class="sidebar-header d-flex justify-content-start align-items-center flex-shrink-0"
    >
      <div
        class="logo-wrapper d-flex align-items-end align-items-center"
        routerLink="/"
        style="cursor: pointer"
      >
        <img
          class="logo"
          src="assets/classjax-logo-light.svg"
          alt="ClassJax Logo"
        />
        <img
          class="logo-name"
          src="assets/classjax-text.png"
          alt="ClassJax Text"
        />
      </div>
    </div>
    <ul class="list-unstyled components">
      <li>
        <a
          routerLink="/classroom"
          routerLinkActive="active"
          (click)="collapseNav()"
        >
          <fa-icon
            [fixedWidth]="true"
            [icon]="icons.classroomIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon>
          <span class="link-name">Classroom</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="sidebarLink('classes')"
          routerLinkActive="active"
          (click)="collapseNav()"
        >
          <fa-icon
            [fixedWidth]="true"
            [icon]="icons.classesIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon>
          <span class="link-name">Classes</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="sidebarLink('planner')"
          routerLinkActive="active"
          (click)="collapseNav()"
        >
          <fa-icon
            [fixedWidth]="true"
            [icon]="icons.plannerIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon>
          <span class="link-name">Planner</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="sidebarLink('standards')"
          routerLinkActive="active"
          (click)="collapseNav()"
        >
          <fa-icon
            [fixedWidth]="true"
            [icon]="icons.standardsIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon>
          <span class="link-name">Standards</span>
        </a>
      </li>
      @if (user$ | async; as user) {
        @if (user.bible_enabled) {
          <li>
            <a
              [routerLink]="sidebarLink('bible')"
              routerLinkActive="active"
              (click)="collapseNav()"
            >
              <fa-icon
                [fixedWidth]="true"
                [icon]="icons.bibleIcon"
                size="lg"
                [fixedWidth]="true"
              ></fa-icon>
              <span class="link-name">Bible</span>
            </a>
          </li>
        }
      }
      <li>
        <a
          [routerLink]="sidebarLink('documents')"
          routerLinkActive="active"
          (click)="collapseNav()"
        >
          <fa-icon
            [fixedWidth]="true"
            [icon]="icons.filesIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon>
          <span class="link-name">Documents</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/artifacts"
          routerLinkActive="active"
          (click)="collapseNav()"
        >
          <fa-icon
            [fixedWidth]="true"
            [icon]="icons.artifactsIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon>
          <span class="link-name">Artifacts</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/usage"
          routerLinkActive="active"
          (click)="collapseNav()"
        >
          <fa-icon
            [fixedWidth]="true"
            [icon]="icons.usageIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon
          ><span class="link-name">Usage</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/safety"
          routerLinkActive="active"
          (click)="collapseNav()"
        >
          <fa-icon
            [fixedWidth]="true"
            [icon]="icons.safetyIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon
          ><span class="link-name">Safety</span>
        </a>
      </li>
      @if (isOrgAdmin$ | async) {
        <li>
          <a [routerLink]="sidebarLink('admin')" routerLinkActive="active" (click)="collapseNav()">
            <fa-icon
              [fixedWidth]="true"
              [icon]="icons.adminIcon"
              size="lg"
              [fixedWidth]="true"
            ></fa-icon>
            <span class="link-name">Admin</span>
          </a>
        </li>
      }
      @if (user$ | async; as user) {
        @if (user.is_super) {
          <li>
            <a
              [routerLink]="sidebarLink('super')"
              routerLinkActive="active"
              (click)="collapseNav()"
            >
              <fa-icon
                [fixedWidth]="true"
                [icon]="icons.superIcon"
                size="lg"
                [fixedWidth]="true"
              ></fa-icon>
              <span class="link-name">Super</span>
            </a>
          </li>
        }
      }
      <li>
        <a
          routerLink="/settings"
          routerLinkActive="active"
          (click)="collapseNav()"
        >
          <fa-icon
            [fixedWidth]="true"
            [icon]="icons.settingsIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon
          ><span class="link-name">Settings</span>
        </a>
      </li>
      <li>
        <a routerLink="./" (click)="signout()">
          <fa-icon
            [fixedWidth]="true"
            [icon]="exitIcon"
            size="lg"
            [fixedWidth]="true"
          ></fa-icon>
          <span class="link-name">Sign out</span>
        </a>
      </li>
    </ul>
    <button
      class="footer-navbar-toggle mt-auto border-top border-light"
      (click)="isNavbarMinimized = !isNavbarMinimized"
    >
      <fa-icon
        [icon]="isNavbarMinimized ? icons.chevronRight : icons.chevronLeft"
        size="lg"
        [fixedWidth]="true"
      >
      </fa-icon>
    </button>
    <!-- <div class="sidebar-background"></div> -->
  </nav>
  <div id="content">
    <nav class="navbar navbar-expand-lg px-3 navbar-dark d-lg-none mobile-nav">
      <div class="container-fluid p-0">
        <div
          class="logo-wrapper d-flex align-items-end align-items-center"
          routerLink="/"
          style="cursor: pointer"
        >
          <img
            class="logo"
            src="assets/classjax-logo-light.svg"
            alt="ClassJax Logo"
          />
          <img
            class="logo-name"
            src="assets/classjax-text.png"
            alt="ClassJax Logo"
          />
        </div>
        <div class="ml-auto d-flex align-items-center">
          <button
            class="navbar-toggler border-0"
            type="button"
            (click)="isNavbarCollapsed = !isNavbarCollapsed"
          >
            <fa-icon
              class="text-light"
              [fixedWidth]="true"
              [icon]="
                isNavbarCollapsed ? icons.menuBarsIcon : icons.menuExitIcon
              "
            ></fa-icon>
          </button>
        </div>
      </div>
    </nav>
    <nav class="navbar navbar-expand-lg navbar-light px-3 d-none d-lg-block">
      <div id="main-nav" class="container-fluid p-0 gap-2">
        <div class="flex-grow-1"></div>
        <div>
          <button
            class="search-btn"
            (click)="openSearch()"
            title="Search (Cmd+K)"
          >
            <fa-icon [icon]="icons.searchIcon"></fa-icon>
            <span class="search-btn-text">Search</span>
            <kbd class="search-shortcut">&#8984;K</kbd>
          </button>
        </div>
        <app-pending-notifications></app-pending-notifications>
        <div class="ml-auto">
          <div class="d-flex align-items-center">
            @if (hasEnrollments$ | async) {
              <a routerLink="/student" class="help-btn" title="Student View">
                <fa-icon [icon]="icons.studentViewIcon"></fa-icon>
              </a>
              <div class="nav-divider"></div>
            }
            @if (assumeSession.isAssuming()) {
              <app-assume-banner></app-assume-banner>
            } @else {
              @if (user$ | async; as user) {
                <div ngbDropdown class="d-inline-block">
                  <button
                    type="button"
                    class="exit-btn"
                    id="profileMenu"
                    ngbDropdownToggle
                  >
                    {{ user.display_name ?? user.email }}
                  </button>
                  <div
                    ngbDropdownMenu
                    aria-labelledby="profileMenu"
                    class="dropdown-menu dropdown-menu-end"
                  >
                    <button ngbDropdownItem (click)="changePassword()">Change Password</button>
                    <div class="dropdown-divider"></div>
                    <button ngbDropdownItem routerLink="/classroom">Classroom</button>
                    <button ngbDropdownItem (click)="openSettings()">Settings</button>
                    <div class="dropdown-divider"></div>
                    <button ngbDropdownItem (click)="signout()">Sign Out</button>
                  </div>
                </div>
              }
            }
            <div class="nav-divider"></div>
            <button class="help-btn" (click)="jaxState.toggleHelp()" title="Help">
              <fa-icon [icon]="icons.helpIcon"></fa-icon>
            </button>
            <div class="nav-divider"></div>
            <button
              class="ai-assistant-btn"
              (click)="jaxState.toggle()"
              title="AI Assistant"
            >
              <fa-icon [icon]="icons.aiIcon"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </nav>
    <app-breadcrumb
      class="content-breadcrumb shadow-sm flex-shrink-0"
    ></app-breadcrumb>
    <div class="p-3 flex-grow-1" style="overflow-y: auto">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- Named outlet for the right-side panel (Jax assistant or Help guide) -->
<router-outlet name="jax"></router-outlet>
